import { FlySvgSprite } from '@fly/svg';
import { ButtonProps as RadixButtonProps } from '@radix-ui/themes';
import classNames from 'classnames';

type FlyCustomColor =
  | 'accent'
  | 'neutral'
  | 'error'
  | 'success'
  | 'warning'
  | 'info';
export type FlyThemeColor =
  | NonNullable<RadixButtonProps['color']>
  | FlyCustomColor;

const flyToRadixColorMap: Record<FlyCustomColor, RadixButtonProps['color']> = {
  accent: 'indigo',
  neutral: 'gray',
  error: 'red',
  success: 'green',
  warning: 'yellow',
  info: 'blue',
};

export const getFlyToRadixColor = (
  color: FlyThemeColor
): RadixButtonProps['color'] => {
  return (
    flyToRadixColorMap[color as FlyCustomColor] ||
    (color as RadixButtonProps['color'])
  );
};

export const renderIcon = (
  icon: React.ReactNode | string,
  size: number,
  iconClassName = ''
) => {
  if (typeof icon === 'string') {
    return (
      <FlySvgSprite
        className={classNames('flex-shrink-0', iconClassName)}
        name={icon}
        size={size}
      />
    );
  }
  return icon;
};
export const strReplaceChars = (
  str: string,
  findChar: string,
  replaceWith: string
): string => {
  return str.split(findChar).join(replaceWith);
};

export const SEPARATOR_TITLE = 'SEPARATOR_TITLE';
